'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _dragAndDropUtils = require('../../utils/dnd/dragAndDropUtils');

var _boardConstants = require('../../../common/boards/boardConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Drop Target functionality. */
/*
 NOTES ON DROP LOCATION:
 Unfortunately due to some discrepancies between the HTML5DragAndDropBackend and the TouchBackend the TouchBackend
 does not guarantee the ordering of drop targets at this point in time.
 This means that the dropping of an element onto another element which is within another element doesn't guarantee
 that the top element will be the first to execute a drop handler function.
 For example, if a board is on top of a canvas and a card is dropped onto a board, there's no guarantee that the
 board's drop handler will fire before the canvas's drop handler.
 As such we need to make sure that all drop targets that can potentially have other drop targets on top of them
 check to see if a child has handled the drop before handling it itself.
 */


// Utils
exports.default = function (props, monitor, component) {
    // Don't handle the drop if it's already been handled by a child.
    if ((0, _dragAndDropUtils.dropTargetAlreadyHandled)(monitor, component)) return;

    var domNode = _reactDom2.default.findDOMNode(component);
    var position = { index: 0 };
    var dropPermitted = props.dropPermitted;


    if (dropPermitted === false) {
        console.warn("You don't have the permission to modify that board.");
        return;
    }

    return {
        location: {
            parentId: props.element.get('id'),
            section: _boardConstants.BOARD_SECTIONS.INBOX,
            position: position
        },
        handledBy: domNode
    };
};

// Constants
// Lib


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/defaultDropLocationFn.js
// module id = 726
// module chunks = 0